module.exports = __webpack_public_path__ + "media/images/grant-2e9d8000beae221f91a673a60b3a0bc2.jpg";